import React from "react";
import styled from "styled-components";

export default styled.section`
    display: none;
    background: black;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 81px;
    z-index: 3;
    right: 0;

    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;